// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { RegistryRef, RegistryUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RegistryActions {
  export class GetAllRegistry {
    static readonly type = '[Registry] GetAllRegistry';
    readonly type = GetAllRegistry.type;
  }

  export class InitRegistrysCount {
    static readonly type = '[Registry] InitRegistryCount';
    readonly type = InitRegistrysCount.type;
  }

  export class InitRegistrys {
    static readonly type = '[Registry] InitRegistrys';
    readonly type = InitRegistrys.type;
  }
  export class CountRegistrys {
    static readonly type = '[Registry] CountRegistrys';
    readonly type = CountRegistrys.type;
  }

  export class CloseRegistrysConnection {
    static readonly type = '[Registry] CloseRegistrysConnection';
    readonly type = CloseRegistrysConnection.type;
  }

  export class GetRegistryById {
    static readonly type = '[Registry] GetRegistryById';
    readonly type = GetRegistryById.type;
  }

  export class UpdateRegistry {
    static readonly type = '[Registry] UpdateRegistry';
    constructor(
      public registryData: Partial<RegistryUpdateData>,
      public ref: RegistryRef,
    ) {}
  }

  export class SetFilter {
    static readonly type = '[Registry] SetFilter';
    constructor(public filterModel: FilterModel | AdvancedFilterModel | null) {}
  }

  export class DeleteRegistrys {
    static readonly type = '[Registry] DeleteRegistrys';
    constructor(public refs: RegistryRef[]) {}
  }

  export class PaginateQueryRegistry {
    static readonly type = '[Registry] PaginateQueryRegistry';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public userId?: string,
    ) {}
  }
  export class RegistryError {
    static readonly type = '[Registry] RegistryError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Registry] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Registry] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public userId?: string,
    ) {}
  }
}
